import Dashboard from "../../dashboard/Dashboard";
import Button from "../../../components/buttons/Button";
import "../../../components/generalComponents.scss";
import style from "../../reviews/review.module.scss";
import { faArrowLeftLong } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useNavigate } from "react-router-dom";

export default function IntroductoryDetails() {
  const router = useNavigate();
  return (
    <Dashboard>
      <>
        <div style={{ display: "flex" }}>
          <FontAwesomeIcon
            icon={faArrowLeftLong}
            onClick={() => router(-1)}
            style={{
              marginTop: "1px",
              marginRight: "0.7rem",
              cursor: "pointer",
            }}
          />
          <h5 style={{ marginRight: "4rem" }}>Introductory Video</h5>
        </div>
        <div className="section">
          <div className={style.textWrapper}>
            <h5>user</h5>
            <p className={style.textStyle}>Ken Okonkwo</p>
          </div>

          <div className={style.textWrapper}>
            <h5>Updated Date</h5>
            <p className={style.textStyle}>12 June, 2025</p>
          </div>

          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <div className={style.videoPreviewContainer}>
              <h5>Video Preview</h5>
              <video
                src="https://www.youtube.com/watch?v=lVVuE3H1CnM"
                controls // Adds video controls like play, pause, etc.
              >
                Your browser does not support the video tag.
              </video>
            </div>
          </div>

          <div className={style.textWrapper} style={{}}>
            <h5>Video Link</h5>

            <a
              className={style.textStyle}
              href="https://www.youtube.com/watch?v=lVVuE3H1CnM"
            >
              https://www.youtube.com/watch?v=lVVuE3H1CnM
            </a>
          </div>

          <hr
            style={{
              marginTop: "1rem",
              marginBottom: "2rem",
              fontWeight: "lighter",
            }}
          />
          <div className="dashboard-button">
            <Button name="Approve" type="activate-button" />
            <Button name="Reject" type="delete-button" />
          </div>
        </div>
      </>
    </Dashboard>
  );
}
